import GeneralDocumentsComponent from './GeneralDocumentsComponent';

export default GeneralDocumentsComponent;